import { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { TRACK } from "@/constants/testIds";
import { toast } from "sonner";

export default function TrackingBar() {
  const [tracking, setTracking] = useState("");

  const submit = (e) => {
    e.preventDefault();
    if (!tracking.trim()) {
      toast.error("Enter a tracking number first.");
      return;
    }
    toast.info(
      "Package tracking launches soon — for an update today, call 470-580-4991 or email support@waylio.com."
    );
    setTracking("");
  };

  return (
    <section data-testid={TRACK.root} className="px-6 md:px-10 mt-8">
      <form
        onSubmit={submit}
        className="max-w-lg mx-auto bg-forest p-4 md:p-5 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-2 md:gap-3"
      >
        <label htmlFor="tracking-input" className="sr-only">
          Tracking number
        </label>
        <input
          id="tracking-input"
          data-testid={TRACK.input}
          value={tracking}
          onChange={(e) => setTracking(e.target.value)}
          placeholder="Tracking #"
          className="flex-1 min-w-0 bg-neutral-200 text-charcoal placeholder:text-charcoal/60 px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-terracotta"
        />
        <button
          type="submit"
          data-testid={TRACK.submit}
          className="group inline-flex items-center justify-center gap-1.5 bg-terracotta hover:bg-terracotta-hover text-cream px-4 md:px-5 py-2.5 text-sm font-bold transition-colors whitespace-nowrap"
        >
          Track My Package
          <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
        </button>
      </form>
    </section>
  );
}
